import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VForm,
        {
          ref: "form",
          staticClass: "form mt-2",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Nombre"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      filled: _vm.readonly,
                      outlined: !_vm.readonly,
                      readonly: _vm.readonly,
                      "hide-details": "auto",
                      dense: "",
                      rules: _vm.rules.general,
                    },
                    model: {
                      value: _vm.report.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "name", $$v)
                      },
                      expression: "report.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Región"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VSelect, {
                    attrs: {
                      filled: _vm.readonly,
                      outlined: !_vm.readonly,
                      readonly: _vm.readonly,
                      "hide-details": "auto",
                      dense: "",
                      items: _vm.regions,
                      rules: _vm.rules.general,
                      "item-text": _vm.itemText,
                      "item-value": _vm.itemValue,
                    },
                    model: {
                      value: _vm.report.region,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "region", $$v)
                      },
                      expression: "report.region",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Herramienta de reporte"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VSelect, {
                    attrs: {
                      items: ["Power BI", "Looker Studio"],
                      rules: _vm.rules.report_tool,
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.report.report_tool,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "report_tool", $$v)
                      },
                      expression: "report.report_tool",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _vm.report.report_tool == "Looker Studio"
                    ? _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v("Key"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _vm.report.report_tool == "Looker Studio"
                    ? _c(VTextField, {
                        attrs: {
                          filled: _vm.readonly,
                          outlined: !_vm.readonly,
                          readonly: _vm.readonly,
                          "hide-details": "auto",
                          dense: "",
                          rules: _vm.rules.general,
                          type: "url",
                        },
                        model: {
                          value: _vm.report.key,
                          callback: function ($$v) {
                            _vm.$set(_vm.report, "key", $$v)
                          },
                          expression: "report.key",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Link"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "10" } },
                [
                  _c(VTextField, {
                    attrs: {
                      filled: _vm.readonly,
                      outlined: !_vm.readonly,
                      readonly: _vm.readonly,
                      "hide-details": "auto",
                      dense: "",
                      rules: _vm.rules.general,
                      type: "url",
                    },
                    model: {
                      value: _vm.report.link,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "link", $$v)
                      },
                      expression: "report.link",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.report.report_tool == "Power BI"
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v("Horas de actualización"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9", lg: "10" } },
                    [
                      _c(VCombobox, {
                        attrs: {
                          multiple: "",
                          chips: "",
                          outlined: "",
                          dense: "",
                          items: _vm.updateHours,
                          "item-text": "hour_formatted",
                          rules: _vm.rules.updateHours,
                          attach: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function (ref) {
                                var attrs = ref.attrs
                                var item = ref.item
                                var parent = ref.parent
                                var selected = ref.selected
                                return [
                                  _c(
                                    VChip,
                                    _vm._b(
                                      {
                                        attrs: {
                                          "input-value": selected,
                                          small: "",
                                        },
                                      },
                                      "v-chip",
                                      attrs,
                                      false
                                    ),
                                    [
                                      _c("span", { staticClass: "pr-1" }, [
                                        _vm._v(_vm._s(item.hour_formatted)),
                                      ]),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: { small: "", dark: "" },
                                          on: {
                                            click: function ($event) {
                                              return parent.selectItem(item)
                                            },
                                          },
                                        },
                                        [_vm._v(" mdi-close ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3414327684
                        ),
                        model: {
                          value: _vm.report.update_hours,
                          callback: function ($$v) {
                            _vm.$set(_vm.report, "update_hours", $$v)
                          },
                          expression: "report.update_hours",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Sección"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VSelect, {
                    attrs: {
                      filled: _vm.readonly,
                      outlined: !_vm.readonly,
                      readonly: _vm.readonly,
                      "hide-details": "auto",
                      dense: "",
                      items: _vm.sections,
                      rules: _vm.rules.general,
                    },
                    on: { change: _vm.changeSection },
                    model: {
                      value: _vm.report.section,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "section", $$v)
                      },
                      expression: "report.section",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Tags"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VCombobox, {
                    attrs: {
                      multiple: "",
                      chips: "",
                      outlined: "",
                      dense: "",
                      items: _vm.tags_global,
                      "item-text": "hour_formatted",
                      rules: _vm.rules.tags,
                      attach: true,
                    },
                    model: {
                      value: _vm.report.tags,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "tags", $$v)
                      },
                      expression: "report.tags",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isOrganizationReport
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v("Empresa"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9", lg: "4" } },
                    [
                      _c(VSelect, {
                        attrs: {
                          filled: _vm.readonly,
                          outlined: !_vm.readonly,
                          readonly: _vm.readonly,
                          "hide-details": "auto",
                          dense: "",
                          items: _vm.organizations,
                          rules: _vm.rules.general,
                          "item-text": _vm.orgText,
                          "item-value": _vm.orgValue,
                        },
                        model: {
                          value: _vm.report.organization,
                          callback: function ($$v) {
                            _vm.$set(_vm.report, "organization", $$v)
                          },
                          expression: "report.organization",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Descripción"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "10" } },
                [
                  _c(VTextarea, {
                    attrs: {
                      "hide-details": "auto",
                      outlined: !_vm.readonly,
                      dense: "",
                      filled: _vm.readonly,
                      readonly: _vm.readonly,
                      rules: _vm.rules.general,
                      required: "",
                      rows: "4",
                    },
                    model: {
                      value: _vm.report.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "description", $$v)
                      },
                      expression: "report.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("En mantenimiento"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VSwitch, {
                    model: {
                      value: _vm.report.maintenance,
                      callback: function ($$v) {
                        _vm.$set(_vm.report, "maintenance", $$v)
                      },
                      expression: "report.maintenance",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }